import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { Service } from "../../../../../models/service";
import { GuideTypesEnum } from "../../../../../models/guideTypes";
import { MuleVersionEnum } from "../../../../../models/muleVersion";
import {Bot} from "../../../../../models/bot";
import {BotControllerService} from "../../../../../services/role-controller/bot-controller.service";
import { SystemPropertiesControllerService } from "../../../../../services/system-settings/system-properties-controller.service";
import { SystemProperties } from "../../../../../models/system-properties";
import { DisplaySystemProperty } from "../../../../../models/display-system-property";

@Component({
  selector: "service-settings-configuration",
  templateUrl: "./service-settings-configuration.component.html",
  providers: [BotControllerService],
})
export class ServiceSettingsConfigurationComponent implements OnInit {

  @Input() public service: Service;
  public bots: Bot[] = [];
  @Input() public disableAutoSave: boolean = false;
  @Input() public guideTypesEnum = GuideTypesEnum;
  @Input() public guideTypesOptions = [];
  public muleVersionEnum = MuleVersionEnum;
  public muleVersionOptions = ["Mule3", "Mule4", "SmartLink"];
  public partBReadOnlyFormOptions = [
    {value: 'TABLE_STYLE', label: 'Table style'},
    {value: 'PART_A_DISABLED_WIP', label: 'Part A disabled (wip)'}
  ];
  public systemProperties: SystemProperties;
  public hideApplicationsList: DisplaySystemProperty;
  public closeApplicationsList: DisplaySystemProperty;
  public readonly guide: string = "Guide";
  public readonly pages: string = "Pages";
  public readonly publishing: string = "Publishing";
  public readonly buttons: string = "Buttons";

  @Output() public saveEmitter = new EventEmitter();

  constructor(
    private botService: BotControllerService,
    private systemPropertiesControllerService: SystemPropertiesControllerService,
  ) { }

  public ngOnInit(): void {
    console.log(this.service);
    if (this.service?.id) {
      this.loadBots();
    }
    if (!this.service.serviceJsonProperties?.guideType) {
      this.service.serviceJsonProperties.guideType = this.guideTypesOptions[2];
    }
    if (!this.service.serviceJsonProperties?.muleVersion) {
      this.service.serviceJsonProperties.muleVersion = MuleVersionEnum[0];
    }
    if (!this.service.serviceJsonProperties?.activateShoppingCartOnEventshoppingCartActiveClick) {
      this.service.serviceJsonProperties.activateShoppingCartOnEventshoppingCartActiveClick = false;
    }
    if (this.service?.isMyAccountPage) {
      this.loadSystemProperties();
    }
  }

  public onChange(event, block: string) {
    if (!this.disableAutoSave) {
      this.saveEmitter.emit(true);
    }
  }

  public autoSave(what: string) {
    if (!this.disableAutoSave) {
      this.saveEmitter.emit(what);
    }
  }

  public updateGuideType(): void {
    if (this.service.serviceJsonProperties.guideType !== this.guideTypesOptions[1]) {
      this.service.serviceJsonProperties.shoppingCartActive = false;
      this.service.serviceJsonProperties.activateShoppingCartOnEvent = false;
    }
  }

  public shoppingCartActiveClick(): void {
    this.service.serviceJsonProperties.shoppingCartActive = !this.service.serviceJsonProperties.shoppingCartActive;
    this.service.serviceJsonProperties.activateShoppingCartOnEvent = false;
    this.service.serviceJsonProperties.hideCostIfMissing = false;
    this.saveEmitter.emit(true);
  }

  public activateShoppingCartOnEventClick(): void {
    this.service.serviceJsonProperties.activateShoppingCartOnEvent = this.service.serviceJsonProperties.shoppingCartActive ? !this.service.serviceJsonProperties.activateShoppingCartOnEvent : false;
    this.saveEmitter.emit(true);
  }

  public loadBots() {
    if (this.service?.id) {
      this.botService.getServicePrintingBots(this.service.id).subscribe(
          (data) => {
            this.bots = data;
          },
      );
    }
  }

  private loadSystemProperties(): void {
    this.systemPropertiesControllerService.getServiceProperties().subscribe(
      (systemProperties) => {
        if (systemProperties) {
          this.systemProperties = systemProperties;
          if (!this.systemProperties.displaySystemProperties) {
            this.systemProperties.displaySystemProperties = [];
          }

          const hideExisting = this.systemProperties.displaySystemProperties.find(
            (p) => p.name === "hide_applications_list"
          );
          if (hideExisting) {
            this.hideApplicationsList = hideExisting;
          } else {
            this.hideApplicationsList = { name: "hide_applications_list", enabled: false };
            this.systemProperties.displaySystemProperties.push(this.hideApplicationsList);
          }

          const closeExisting = this.systemProperties.displaySystemProperties.find(
            (p) => p.name === "close_applications_list"
          );
          if (closeExisting) {
            this.closeApplicationsList = closeExisting;
          } else {
            this.closeApplicationsList = { name: "close_applications_list", enabled: true };
            this.systemProperties.displaySystemProperties.push(this.closeApplicationsList);
          }
        }
      },
    );
  }

  public updateSystemProperties(): void {
    this.systemPropertiesControllerService.updateServiceProperties(this.systemProperties).subscribe();
  }

}
